import { render, staticRenderFns } from "./CreateObjectsTab.vue?vue&type=template&id=d0090c30&scoped=true"
import script from "./CreateObjectsTab.vue?vue&type=script&lang=js"
export * from "./CreateObjectsTab.vue?vue&type=script&lang=js"
import style0 from "./CreateObjectsTab.vue?vue&type=style&index=0&id=d0090c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0090c30",
  null
  
)

export default component.exports